// extracted by mini-css-extract-plugin
module.exports = {"stepperVague":"style_stepperVague__1B7UK","stepperVague_chevronLeft":"style_stepperVague_chevronLeft__1_CUb","stepperVague_chevronRight":"style_stepperVague_chevronRight__8NPmk"};